import React from "react";
import BreadCrumbs from "../../components/BreadCrumbs/BreadCrumbs";
import styles from "./dataVaultModelling.module.scss";
import { MappingWorkspace } from "../mapping/MappingWorkspace";

const breadCrumbs = [
  { name: "Ensemble Modelling", url: "/ensembleModelling" },
  {
    name: "Data Vault Modelling",
    url: "/data-vault-modelling",
  },
  { name: "Data Mart Modelling", url: "/data-mart-modelling" },
  { name: "Import Data Model", url: "/importDataModel" }
];

const DataVaultModelling: React.FC = () => {
  return (
    <div className={styles.page}>
      <BreadCrumbs breadCrumbsData={breadCrumbs} />
      <section style={{ marginTop: "35px" }}>
        {/* <div className={styles.header}>
          <div>
            <p>Data Vault Studio</p>
            <h1>Visual Data Vault Modelling</h1>
          </div>
        </div> */}
        <div className={`${styles.workspace} ${styles.workspaceFixed}`}>
          <div className={styles.workspaceFill}>
            <MappingWorkspace />
          </div>
        </div>
      </section>
    </div>
  );
};

export default DataVaultModelling;
